
import { TraineeActions } from "./actions/TraineeActions";
import { AdminActions } from "./actions/AdminActions";

interface ResourceCardActionsProps {
  isResourceCompleted?: boolean;
  isCompleted?: boolean; 
  showCertificateButton?: boolean;
  isTrainee: boolean;
  onPreviewClick?: () => void;
  onDownloadCertificate?: () => void;
  resourceId: string;
  topic: string;
  company: string;
  previewImageUrl?: string | null;
  isMobile?: boolean;
}

export function ResourceCardActions({
  isResourceCompleted,
  isCompleted,
  showCertificateButton,
  isTrainee,
  onPreviewClick = () => {},
  onDownloadCertificate = () => {},
  resourceId,
  topic,
  company,
  previewImageUrl,
  isMobile = false
}: ResourceCardActionsProps) {
  // Use either isResourceCompleted or isCompleted
  const completed = isResourceCompleted || isCompleted || false;

  // Rendering different UIs for trainee and admin
  if (isTrainee) {
    return (
      <TraineeActions
        resourceId={resourceId}
        topic={topic}
        company={company}
        previewImageUrl={previewImageUrl}
        isCompleted={completed}
        showCertificateButton={showCertificateButton}
        onPreviewClick={onPreviewClick}
        isMobile={isMobile}
      />
    );
  }
  
  // Admin view
  return (
    <AdminActions
      resourceId={resourceId}
      topic={topic}
      company={company}
      previewImageUrl={previewImageUrl}
      onPreviewClick={onPreviewClick}
      isMobile={isMobile}
    />
  );
}
